module.exports = __webpack_public_path__ + "img/hr-green-asterisk-14.72b6fe14.png";